module.exports = __webpack_public_path__ + "static/rimyi_img-8fedc542189a1ae4208a96d04aa3455e.jpg";